// extracted by mini-css-extract-plugin
export default {"genericCard":"nn-z","inline":"on-z","mastercard":"pn-z","discover":"qn-z","visa":"rn-z","amex":"sn-z","active":"tn-z"};